import React from "react"
import { Link } from "@reach/router"
import starIcon from "../../../../../assets/icons/star.svg"
import styles from "./Tile.scss"

interface IProps {
  title: string
  price: number
  sessionsNumber: number
  picture: string
  duration: number
  index: number
  size?: string
}

const renderPrice = (price: number, isTest: boolean) => {
  if (isTest) {
    return (
      <>
        <span id="linedThrough">{`${price}€`}</span>
        <span> {` ${price / 2}€`}</span>
      </>
    )
  }
  return <span>{`${price}€`}</span>
}

const renderPic = (
  picture: string,
  price: number,
  isTest: boolean,
  color: string,
  score: number
) => (
  <div>
    <div>{renderPrice(price, isTest)}</div>
    <img src={picture} alt={picture} />
    <div>
      {score}
      <img src={starIcon} alt="star" />
    </div>
    {isTest && (
      <span className={styles[`background${color}`]}>
        NOUVEAUTÉ <br />
        -50%
      </span>
    )}
  </div>
)

const Tile = ({
  title,
  price,
  categories,
  location,
  picture,
  minMaxParticipants,
  index,
  isTest,
}: IProps) => {
  const { min, max } = minMaxParticipants
  const score = 4.4
  return (
    <div className={styles.disableLinkStyles}>
      <Link to={`/experience/${title}`}>
        <div className={[styles.small, styles.tile, styles.shadow].join(" ")}>
          {renderPic(picture, price, isTest, "Pink", score)}
          <div>{location}</div>
          <div className={styles.backgroundPink}>
            <span>{`${min} ${max === min ? "" : `- ${max}`} pers.`}</span>
            <span>
              {categories[0]}
              {categories.length > 1 && (
                <div>
                  <div>{`${categories.length - 1}`}</div>
                  <div>
                    {categories
                      .filter((_, i) => i > 0)
                      .map((cat) => (
                        <div key={cat}>{cat}</div>
                      ))}
                  </div>
                </div>
              )}
            </span>
          </div>
          <div>
            <div>{title}</div>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default Tile
